import produce from "immer";
import { verifyIfCanSave } from "./verifyIfCanSave";

import { State } from "../types";

export function updateRuleLabels(
  state: State,
  payload: UpdateRuleLabels["payload"]
): State {
  const { type, input } = payload;
  return produce(state, draft => {
    if (type === "name") {
      draft.rule.name = input;
      verifyIfCanSave(draft);
    }
    if (type === "description") {
      draft.rule.description = input;
    }
    if (type === "locale") {
      if (input) {
        draft.rule.locale = input;
      } else {
        delete draft.rule.locale;
      }
    }
    if (type === "timeZone") {
      if (input) {
        draft.rule.timeZone = input;
      } else {
        delete draft.rule.timeZone;
      }
    }
  });
}

export type UpdateRuleLabels = {
  type: "updateRuleLabels";
  payload: {
    type: "name" | "description" | "locale" | "timeZone";
    input: string;
  };
};
